"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = exports.getClassName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Heading_module_css_1 = __importDefault(require("./Heading.module.css"));
/**
 * Get the class name for a heading style
 */
function getClassName(size, emphasis) {
    switch (size) {
        case "H1":
            return Heading_module_css_1.default.h100;
        case "H2":
            return Heading_module_css_1.default.h200;
        case "H3":
            return Heading_module_css_1.default.h300;
        case "H4":
            if (emphasis) {
                return Heading_module_css_1.default.h400Emphasis;
            }
            return Heading_module_css_1.default.h400;
        case "H5":
            if (emphasis) {
                return Heading_module_css_1.default.h500Emphasis;
            }
            return Heading_module_css_1.default.h500;
        case "H6":
            if (emphasis) {
                return Heading_module_css_1.default.h600Emphasis;
            }
            return Heading_module_css_1.default.h600;
        case "H7":
            if (emphasis) {
                return Heading_module_css_1.default.h700Emphasis;
            }
            return Heading_module_css_1.default.h700;
        case "H8":
            return Heading_module_css_1.default.h800;
        case "H9":
            return Heading_module_css_1.default.h900;
    }
}
exports.getClassName = getClassName;
/**
 * Renders a heading component
 * @param props Component props
 * @constructor
 */
function Heading(props) {
    const { size, tag = "", emphasis, children } = props;
    let Tag;
    switch (tag) {
        case "H1":
        case "H2":
        case "H3":
        case "H4":
        case "H5":
        case "H6":
            Tag = tag.toLowerCase();
            break;
        case "H7":
        case "H8":
        default:
            // There are h1-h6 HTML tags, for the remaining styles, simply use divs
            Tag = "div";
            break;
        case "":
            // When tag is not specified, deduce it from size:
            Tag = size.toLowerCase();
    }
    // Get rid of TS error: TS2322: Type '{ children: ReactNode; className: string; }' is not
    // assignable to type 'IntrinsicAttributes'.
    Tag = Tag;
    const className = getClassName(size, Boolean(emphasis));
    return (0, jsx_runtime_1.jsx)(Tag, { className: className, children: children });
}
exports.Heading = Heading;
//# sourceMappingURL=Heading.js.map